import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { KeyFilterModule } from 'primeng/keyfilter';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarComponent } from './calendar/calendar.component';
import { CheckboxButtonGroupComponent } from './checkbox-button-group/checkbox-button-group.component';
import { CheckboxButtonComponent } from './checkbox-button/checkbox-button.component';
import { CheckboxGroupComponent } from './checkbox-group/checkbox-group.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { ControlComponent } from './control/control.component';
import { DownloadFileComponent } from './download-file/download-file.component';
import { ErrorValidationComponent } from './error-validation/error-validation.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { LabelInfoComponent } from './label-info/label-info.component';
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { PriceModelComponent } from './price-model/price-model.component';
import { RadioButtonGroupComponent } from './radio-button-group/radio-button-group.component';
import { RadioGroupComponent } from './radio-group/radio-group.component';
import { SelectInputComponent } from './select-input/select-input.component';
import {AutoCompleteModule} from 'primeng/autocomplete';

@NgModule({
  declarations: [
    CheckboxGroupComponent,
    ControlComponent,
    DownloadFileComponent,
    ErrorValidationComponent,
    FileUploadComponent,
    LabelInfoComponent,
    PriceModelComponent,
    RadioGroupComponent,
    SelectInputComponent,
    CheckboxComponent,
    RadioButtonGroupComponent,
    CheckboxButtonGroupComponent,
    CalendarComponent,
    PhoneInputComponent,
    CheckboxButtonComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    MessageModule,
    DropdownModule,
    TooltipModule,
    CalendarModule,
    MultiSelectModule,
    FileUploadModule,
    InputMaskModule,
    RadioButtonModule,
    KeyFilterModule,
    CheckboxModule,
    InputNumberModule,
    InputTextModule,
    AutoCompleteModule
  ],
  exports: [
    CheckboxComponent,
    ControlComponent,
    DownloadFileComponent,
    ErrorValidationComponent,
    FileUploadComponent,
    LabelInfoComponent,
    PriceModelComponent,
    RadioGroupComponent,
    CheckboxGroupComponent,
    SelectInputComponent,
    RadioButtonGroupComponent,
    CheckboxModule,
    PhoneInputComponent,
    CheckboxButtonComponent,
  ],
})
export class CustomControlsModule {}
